import { useQuery } from '@tanstack/react-query';

import { queries } from '../api/queryKeys/queries';

export const usePortDirectoryDetails = ({ portId, supplierGroupId }) => {
    const thirtyMinutes = 30 * 60 * 1000;

    return useQuery({
        ...queries.ports.directories(portId, supplierGroupId),
        staleTime: thirtyMinutes,
        throwOnError: false,
        retry: (_, error) => {
            return error.response?.status !== 404;
        },
        refetchOnWindowFocus: false,
    });
};
